import { Children, cloneElement, useEffect } from 'react';
import { playSound, Sound } from '~/assets/sounds';
import { useInputAction } from '~/rage';
import { InputAction } from '~/shared';
import {
	setTabIndex,
	setTabIndexNext,
	setTabIndexPrev,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { TabLine } from '../TabLine';
import { StyledContainer } from './TabsContainer.styled';

const TabsContainer = ({
	children,
	...props
}: React.HTMLAttributes<HTMLDivElement>) => {
	const dispatch = useLayoutDispatch();
	const workTabIndex = useLayoutSelector((state) => state.handling.tabIndex);

	useInputAction(InputAction.CommonTabNavLeft, () => {
		dispatch(setTabIndexPrev());
	});
	useInputAction(InputAction.CommonTabNavRight, () => {
		dispatch(setTabIndexNext());
	});

	useEffect(() => {
		const tabElement = document.getElementById(`tab#${workTabIndex}`);
		if (tabElement !== null) {
			tabElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
		}
	}, [workTabIndex]);

	useEffect(() => {
		const tabElement = document.getElementById(`tab#${workTabIndex}`);
		const lineElement = document.getElementById(`tab#line`);
		if (tabElement !== null && lineElement !== null) {
			const tabWidth = window.getComputedStyle(tabElement).width;
			lineElement.style.setProperty('--width', tabWidth);
			lineElement.style.setProperty('--left', `${tabElement.offsetLeft}px`);
		}
	}, [workTabIndex]);

	return (
		<StyledContainer {...props}>
			{Children.map(children, (child: any, index) => {
				return cloneElement(child, {
					id: `tab#${index}`,
					onClick: () => {
						playSound(Sound.ClickButton);
						dispatch(setTabIndex(index));
					},
					$selected: index == workTabIndex,
					onMouseEnter: () => {
						playSound(Sound.LinkCursor);
					},
				});
			})}
			<TabLine id="tab#line" />
		</StyledContainer>
	);
};

export { TabsContainer };
